import React from 'react';
/**
 * We are still seeing unexpected token errors in jest tests which could be
 * due to @babel problems that haven't been resolved or implemented
 */
// eslint-disable-next-line no-restricted-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { css } from '@compiled/react';

import { N100 } from '@atlaskit/theme/colors';
import Page16Icon from '@atlaskit/icon-object/glyph/page/16';
import { token } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';

import { HeightAdjustedContainer } from './HeightAdjustedContainer';
import { ColumnWidths } from './tasksDefinitions';
import { HeightAdjustingText } from './HeightAdjustingText';
import { TruncatedTextCacheKeys } from './TaskRowsContext';

interface PageProps {
	taskId: string; // The ID with the associated task.
	page: string; // The name of the page for the given task.
	url?: string;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled(HeightAdjustedContainer)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: ColumnWidths.Main,
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span': {
		marginTop: 4,
	},
});

const containerStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: 270,
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span': {
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		marginTop: 4,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextWrapper = styled.div({
	height: '100%',
	width: '100%',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingLeft: 10,
	display: 'flex',
	alignItems: 'flex-start',
	color: token('color.text', N100),

	// line-height is 20px by default and the icon is 16px so
	marginTop: token('space.negative.025', '-2px'),
});

const textWrapperStyles = css({
	height: '100%',
	width: '100%',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingLeft: 10,
	display: 'flex',
	alignItems: 'flex-start',
	color: token('color.text', N100),

	// line-height is 20px by default and the icon is 16px so
	marginTop: token('space.negative.025', '-2px'),
});

export const PageColumn = ({ taskId, page, url }: PageProps) => {
	if (fg('confluence_frontend_home_compiled_migration')) {
		return (
			<HeightAdjustedContainer css={containerStyles} taskId={taskId}>
				<Page16Icon label="page title icon" />
				<div css={textWrapperStyles} data-testid="page-column">
					<HeightAdjustingText
						taskId={taskId}
						defaultText={page}
						cacheKey={TruncatedTextCacheKeys.PAGE}
						url={url}
					/>
				</div>
			</HeightAdjustedContainer>
		);
	}

	return (
		<Container taskId={taskId}>
			<Page16Icon label="page title icon" />
			<TextWrapper data-testid="page-column">
				<HeightAdjustingText
					taskId={taskId}
					defaultText={page}
					cacheKey={TruncatedTextCacheKeys.PAGE}
					url={url}
				/>
			</TextWrapper>
		</Container>
	);
};
